// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"2940f5bb202fd09d","218":"f971a05ca712a2ef"}[chunkId] + ".js";
};